import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { getApi } from "../../services/api/globalApi";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { sldierListColumns } from "../../constant/tablesColumns/tablesColums";
import Button from "../../components/common/button/Button";

export default function SliderList() {
  const [slierData, setSliderData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const { utils } = useSelector(utilsState);

  const getUser = async (params) => {
    const path = "admin/sliders";
    try {
      const response = await getApi({ path, params: { ...params } });
      setSliderData(response?.data?.result.data);
      setPagination(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getUser(allFilter);
  };

  const data = [];

  slierData?.map((item) =>
    data.push({
      ...item,
      faPart: utils?.SLIDER_PART[item?.part]?.name || "",
      faPosition: utils?.SLIDER_POSITION[item?.position]?.name || "",
      key: item._id,
      id: item._id,
      createdAt: "1403",
    })
  );

  console.log(data);

  const navigate = useNavigate();

  const editUser = (singleUser) => {
    navigate("/edit-slider", { state: singleUser });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex justify-between items-center mb-6 gap-4">
        <Title title={"لیست اسلایدر ها"} />
        <Button
          onClick={() => navigate("/add-slider")}
          text="افزودن اسلایدر"
          color="success"
          type="button"
          className="whitespace-nowrap min-w-fit"
        />
      </div>

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
      <Table columns={sldierListColumns} rows={data} onEdit={editUser} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
